import { render, staticRenderFns } from "./CardTra.vue?vue&type=template&id=74622259&"
import script from "./CardTra.vue?vue&type=script&lang=js&"
export * from "./CardTra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports